import { render, staticRenderFns } from "./channelAccess.vue?vue&type=template&id=1678aaf9&scoped=true"
import script from "./channelAccess.vue?vue&type=script&lang=js"
export * from "./channelAccess.vue?vue&type=script&lang=js"
import style0 from "./channelAccess.vue?vue&type=style&index=0&id=1678aaf9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678aaf9",
  null
  
)

export default component.exports